import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiFetch } from './utils/api';
import PageHeader from './components/PageHeader';

function DailyPlanningLanding() {
  const navigate = useNavigate();
  const [modules, setModules] = useState({ fleet_tracking: false });

  useEffect(() => {
    apiFetch('/api/company-settings')
      .then(res => res.json())
      .then(data => {
        if (data && data.id) {
          setModules({
            fleet_tracking: data.module_fleet_tracking !== false
          });
        }
      })
      .catch(err => console.error('Error fetching modules:', err));
  }, []);

  const allPlanningItems = [
    {
      path: '/ops/fleet-tracking',
      label: 'Fleet Tracking',
      icon: '🚗',
      description: 'Live vehicle locations and GPS monitoring',
      available: true,
      requiresModule: 'fleet_tracking'
    },

    {
      path: '/ops/engineer-dispatch',
      label: 'Engineer Dispatch',
      icon: '📋',
      description: 'Daily schedule with drag-and-drop job assignments',
      available: true
    },
    {
      path: '/route-optimization',
      label: 'Route Optimization',
      icon: '🗺️',
      description: 'Optimize engineer routes for efficiency',
      available: false
    }
  ];

  const planningItems = allPlanningItems.filter(item =>
    !item.requiresModule || modules[item.requiresModule]
  );

  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader
        title="Daily Planning & Operations"
        subtitle="Fleet tracking, scheduling, and resource management"
        sticky
      />
      <main className="max-w-6xl mx-auto px-6 py-8">
        <div className="mx-auto" style={{ width: 'fit-content', maxWidth: '1200px' }}>
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-8">
            <div className="flex items-start space-x-3">
              <span className="text-2xl">📅</span>
              <div>
                <h3 className="font-semibold text-blue-900 mb-1">Daily Planning Hub</h3>
                <p className="text-sm text-blue-800">Centralized control for daily operations - track vehicles, schedule engineers, optimize routes, and monitor job progress in real-time.</p>
              </div>
            </div>
          </div>
          <div className="bg-gray-300 rounded-lg shadow p-6">
            <h2 className="text-xl font-semibold text-gray-800 mb-6">Quick Access</h2>
            <div className="grid grid-cols-3 gap-4 justify-items-center">
              {planningItems.map((item) => (
                <button key={item.path} onClick={() => item.available && navigate(item.path)} disabled={!item.available} className={`flex flex-col items-start p-6 rounded-lg border-2 transition-all text-left w-full max-w-xs ${item.available ? 'bg-white border-black hover:border-blue-500 hover:shadow-lg cursor-pointer group' : 'border-gray-100 bg-gray-50 cursor-not-allowed opacity-60'}`}>
                  <div className="flex items-center justify-between w-full mb-3">
                    <span className={`text-5xl transition-transform ${item.available ? 'group-hover:scale-110' : ''}`}>{item.icon}</span>
                    {!item.available && <span className="text-xs bg-gray-200 text-gray-600 px-2 py-1 rounded-full">Coming Soon</span>}
                  </div>
                  <h3 className={`text-lg font-semibold mb-2 ${item.available ? 'text-gray-900' : 'text-gray-500'}`}>{item.label}</h3>
                  <p className={`text-sm ${item.available ? 'text-gray-600' : 'text-gray-400'}`}>{item.description}</p>
                </button>
              ))}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default DailyPlanningLanding;
